<template>
    <div class="panel panel-default">
        <div class="panel-heading" v-text="trans.header"></div>
        <div class="panel-body">
            <div class="form-group">
                <select-product-autocomplete
                        input_index="0"
                        :exclude="excluded_autocomplete"
                        :placeholder="trans.search_placeholder"
                ></select-product-autocomplete>
            </div>

            <draggable v-model="products_list" ghost-class="ghost">
                <transition-group type="transition" name="flip-list">
                    <div class="row product-container" v-for="(product, index) in products_list" :key="product.id">
                        <div class="col-md-11">
                            <div class="form-control" v-text="product.name"></div>
                            <input type="hidden" :name="`products[${product.id}][sorting]`" :value="index">
                        </div>
                        <div class="col-md-1">
                            <i class="fa fa-arrows text-olive move-btn"></i>
                            <a href="#"
                               @click="remove(index)"
                               class="btn btn-primary btn-danger btn-xs b-remove-pack__button remove-btn">
                                <i class="fa fa-ban"></i>
                            </a>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: "products-group",
        props: {
            trans: Object,
            products: Array
        },
        component: {
            draggable,
        },
        data() {
            return {
                products_list: []
            };
        },
        created() {
            this.initProductsList();
            this.$root.$on('select-product-autocomplete:product_selected', this.onProductSelected);
        },
        computed: {
            excluded_autocomplete() {
                return this.products_list.map(product => product.id);
            }
        },
        methods: {
            initProductsList() {
                this.products.map((product) => {
                    this.products_list.push(
                        this.transformProduct(product)
                    );
                });
            },
            onProductSelected(product) {
                this.products_list.push(
                    this.transformProduct(product)
                );
            },
            transformProduct(product) {
                return {
                    id: product.id,
                    name: product.name,
                };
            },
            remove(index) {
                this.products_list.splice(index, 1);
            }
        },
    }
</script>

<style scoped>
    .product-container {
        margin-bottom: 15px;
    }
    .move-btn {
        font-size: 20px;
        margin-top: 5px;
        cursor: pointer;
    }
    .remove-btn {
        float: right;
        margin-top: 5px;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .ghost {
        border-left: 5px solid #3d9970;
    }
</style>